import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';

export default class SyncIndicator extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    // this.handleTouchTap = this.handleTouchTap.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  // handleTouchTap() {
  //   this.setState({
  //     open: true
  //   });
  // };
  //
  handleRequestClose() {
    this.setState({
      open: false
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage && nextProps.errorMessage.length) {
      this.setState({
        open: true
      });
    }
  }

  render() {
    return (
      <div>
        <Snackbar
          open={this.props.isSyncing}
          message={<span>Syncing changes<CircularProgress style={{display:"inline-block", position: "absolute"}} size={0.5} /></span>}
        />

        <Snackbar
          bodyStyle={{backgroundColor:"red"}}
          open={this.state.open}
          message={this.props.errorMessage || ""}
          autoHideDuration={8000}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}
